<!--
 * @Author: lsh
 * @Date: 2021-03-01 14:38:23
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-09-23 14:54:13
 * @Descripttion: 
 * @FilePath: \scwater_development\src\views\projectOnly\investManage\components\InvestInPlace.vue
-->
<template>
  <div>
    <div class="count-wrap">
      <div class="item" v-for="(item, index) in tapData" :key="index">
        <el-popover placement="right" width="180" trigger="hover">
          <div
            class="ignore-wrap"
            style="text-align: left; margin: 0"
            v-show="item.name == '当年到位投资'"
          >
            <p v-if="tapDtData.thisYear">
              <i class="blue"></i>中央投资： <b>{{ tapDtData.thisYear.zyzj }}</b
              >万元
            </p>
            <p v-if="tapDtData.thisYear">
              <i class="blue"></i>省级投资： <b>{{ tapDtData.thisYear.sjzj }}</b
              >万元
            </p>
            <p v-if="tapDtData.thisYear">
              <i class="blue"></i>地方投资： <b>{{ tapDtData.thisYear.dfzj }}</b
              >万元
            </p>
            <p v-if="tapDtData.thisYear">
              <i class="blue"></i>其他： <b>{{ tapDtData.thisYear.other }}</b
              >万元
            </p>
          </div>
          <div
            class="ignore-wrap"
            style="text-align: left; margin: 0"
            v-show="item.name == '累计到位投资'"
          >
            <p v-if="tapDtData.total">
              <i class="blue"></i>中央投资： <b>{{ tapDtData.total.zyzj }}</b
              >万元
            </p>
            <p v-if="tapDtData.total">
              <i class="blue"></i>省级投资： <b>{{ tapDtData.total.sjzj }}</b
              >万元
            </p>
            <p v-if="tapDtData.total">
              <i class="blue"></i>地方投资： <b>{{ tapDtData.total.dfzj }}</b
              >万元
            </p>
            <p v-if="tapDtData.total">
              <i class="blue"></i>其他： <b>{{ tapDtData.total.other }}</b
              >万元
            </p>
          </div>
          <div
            style="text-align: left; margin: 0"
            v-show="item.name == '累计到位投资率'"
          >
            累计到位投资率=累计到位投资/计划总投资
          </div>
          <div slot="reference" class="num-wrap">
            <div>{{ item.name }}</div>
            <div>
              <b :class="item.cls">{{ item.num }}</b>
              {{ item.unit }}
            </div>
          </div>
        </el-popover>
        <img :src="item.img" alt />
      </div>
    </div>
    <div class="warp-box box_shadow">
      <div class="select-wrap">
        <el-radio-group
          @change="handleClick"
          v-model="tabPosition"
          style="margin-right: 20px"
        >
          <el-radio-button
            :label="item.id"
            v-for="(item, index) in selectList"
            :key="index"
            >{{ item.name }}</el-radio-button
          >
        </el-radio-group>
        <el-button
          type="primary"
          plain
          style="margin-right: 10px"
          @click="exportData()"
          >导出</el-button
        >
        <el-button
          type="primary"
          style="margin-right: 10px"
          plain
          @click="importExcel()"
          >导入</el-button
        >
        <!-- <div class="right"> -->
        <!-- <el-input
          placeholder="请输入关键字"
          prefix-icon="el-icon-search"
          @change="getList"
          v-model="listQuery.name"
          style="width: 240px; margin-left: 15px"
        />-->
        <!-- <el-button
          type="primary"
          @click="editTable('新增')"
          style="float: left; margin-right: 15px"
           >新增</el-button
        >-->
        <!-- </div> -->
      </div>
      <div class="card-wrap">
        <div class="item add" @click="editTable()">
          <span class="el-icon-circle-plus-outline"></span>
          <p>新增</p>
        </div>
        <div class="item" v-for="item in listData" :key="item.id">
          <div class="info-box">
            <div class="info">
              <div>
                <img
                  v-if="item.moneyType == '中央资金'"
                  src="./../../../../assets/images/zhongyang.png"
                  alt
                />
                <img
                  v-if="item.moneyType == '省级资金'"
                  src="./../../../../assets/images/shengji.png"
                  alt
                />
                <img
                  v-if="item.moneyType == '地方资金'"
                  src="./../../../../assets/images/difang.png"
                  alt
                />
                <img
                  v-if="item.moneyType == '其他'"
                  src="./../../../../assets/images/qita.png"
                  alt
                />
              </div>
              <div>
                <p>{{ item.moneyType }}</p>
                <p class="num">
                  <b
                    :class="{
                      zy_color: item.moneyType == '中央资金',
                      df_color: item.moneyType == '地方资金',
                      qt_color: item.moneyType == '其他',
                    }"
                    >{{ item.money }}</b
                  >
                  万元
                </p>
              </div>
            </div>
            <div class="line"></div>
            <div class="link">
              <span @click="openUrl(item)">
                附件：
                <img src="../../../../assets/images/link-address.png" alt />
              </span>
              <span>
                到位时间：
                <b>{{ item.receiveTime }}</b>
              </span>
            </div>
          </div>
          <div class="line"></div>
          <div class="btn">
            <span @click="editTable(item)"> <i></i>编辑 </span>
            <span @click="del(item)"> <i></i>删除 </span>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :title="title"
      class="common_table_dialog"
      :visible.sync="showEditCardDialog"
      v-if="showEditCardDialog"
      :close-on-click-modal="false"
      width="540px"
    >
      <plan-edit
        @closeeditdialog="closeeditdialog"
        :editObj="editObj"
        @lookFile="lookFile"
      ></plan-edit>
    </el-dialog>

    <el-dialog
      title="查看文件"
      fullscreen
      :visible.sync="showFileDialog"
      width="85%"
    >
      <look-file v-if="showFile" :url="previewUrl"></look-file>
    </el-dialog>
    <import-data
      v-if="showImportDialog"
      :showImportDialog="showImportDialog"
      leadInUrl="/mgt/bs-proj-receive-money/excelToReceiveMoney"
      downloadTemplate="到位资金导入模板.xlsx"
      @closeImportDialog="closeImportDialog"
    />
  </div>
</template>

<script>
import { investInPlaceApi } from "@/api/projectOnly";
import planEdit from "./InPlaceDialog";

export default {
  name: "investInPlace",
  components: { planEdit },
  data() {
    return {
      showImportDialog: false,
      tapData: [
        {
          name: "当年到位投资",
          img: require("../../../../assets/images/invest_plan_1.svg"),
          num: 0,
          unit: "万元",
          cls: "c1",
        },
        {
          name: "累计到位投资",
          img: require("../../../../assets/images/invest_plan_2.svg"),
          num: 0,
          unit: "万元",
          cls: "c2",
        },
        {
          name: "累计到位投资率",
          img: require("../../../../assets/images/invest_plan_3.svg"),
          num: 0,
          unit: "%",
          cls: "c3",
        },
      ],
      tapDtData: {},
      selectList: [
        {
          name: "全部",
          id: "",
        },
        {
          name: "中央资金",
          id: "中央资金",
        },
        {
          name: "省级资金",
          id: "省级资金",
        },
        {
          name: "地方资金",
          id: "地方资金",
        },
        {
          name: "其他",
          id: "其他",
        },
      ],
      selectActive: "",
      listQuery: {
        name: "",
      },
      loading: true,
      listData: [],
      showEditCardDialog: false,
      title: "",
      editObj: {},
      showFile: false,
      showFileDialog: false,
      previewUrl: "",
      tabPosition: "",
    };
  },
  created() {
    this.getList();
    this.getCount();
  },
  mounted() {},
  methods: {
    closeImportDialog(type) {
      if (type == 1) {
        this.getList();
        this.getCount();
      } else {
        this.showImportDialog = false;
      }
    },
    importExcel() {
      this.showImportDialog = true;
    },
    exportData() {
      let token = this.$localData("get", "userInfo").token;
      let exportUrl =
        this.$config.baseUrl +
        "/mgt/bs-proj-receive-money/listToExcel" +
        "?token=" +
        token +
        "&projCode=" +
        this.$store.state.projectDetail.code +
        "&name=" +
        this.listQuery.name +
        "&moneyType=" +
        this.selectActive;
      window.open(exportUrl);
    },
    handleClick(item) {
      this.selectActive = item;
      this.getList();
    },
    openUrl(item) {
      if (item.filePathList && item.filePathList.length > 0) {
        this.lookFile(item.filePathList[0]);
      } else {
        this.$message("暂无附件请先上传！");
      }
    },
    lookFile(file) {
      this.previewUrl = file.response ? file.response.filePath : file.path;
      this.showFile = false;
      this.$nextTick(() => {
        this.showFile = true;
      });
      this.showFileDialog = true;
    },
    getList() {
      this.loading = true;

      investInPlaceApi
        .list({
          projCode: this.$store.state.projectDetail.code,
          name: this.listQuery.name,
          moneyType: this.selectActive,
        })
        .then((res) => {
          if (res.success) {
            this.listData = res.rows;
            this.loading = false;
          }
        });
    },
    getCount() {
      investInPlaceApi
        .count({
          projCode: this.$store.state.projectDetail.code,
          planYear: String(new Date().getFullYear()),
        })
        .then((res) => {
          this.tapData[1].num = res.totalCapital;
          this.tapData[2].num = res.rate;
          this.tapData[0].num = res.thisYearCapital;
          this.tapDtData = res;
        });
    },
    del(item) {
      this.$confirm("此操作将删除该条数据, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        investInPlaceApi
          .del({
            id: item.id,
            projCode: this.$store.state.projectDetail.code,
          })
          .then((res) => {
            if (res.success) {
              this.$message({
                message: "删除成功！",
                type: "success",
                duration: "1000",
                onClose: () => {},
              });
              this.getList();
              this.getCount();
            } else {
              this.$message.error("删除失败！");
            }
          });
      });
    },
    editTable(item) {
      if (item) {
        this.title = "编辑到位投资";
        this.editObj = item;
        console.log("this.editObj: ", this.editObj);
      } else {
        this.title = "新增到位投资";
        this.editObj = {};
      }
      this.showEditCardDialog = true;
    },
    closeeditdialog() {
      this.showEditCardDialog = false;
      this.getList();
      this.getCount();
    },
  },
};
</script>
<style lang="scss" scoped>
.count-wrap {
  padding-top: 20px;
  display: flex;
  justify-items: center;
  justify-content: space-between;
  position: relative;
  .item {
    width: 32%;
    display: flex;
    justify-items: center;
    justify-content: space-between;
    align-items: center;
    padding: 2% 1%;
    background: #fff;
    box-shadow: 0 0 15px 0 rgba(66, 75, 113, 0.1);
    font-size: 16px;
    color: #333333;
    letter-spacing: 1.33px;
    box-sizing: border-box;
    .icon {
      position: absolute;
      right: 24px;
      top: 26px;
      background: url("../../../../assets/images/question.png");
      width: 14px;
      height: 14px;
      display: inline-block;
    }
    .num-wrap {
      > div:nth-child(1) {
        font-size: 16px;
        color: #333333;
        padding-bottom: 13px;
      }
    }
    b {
      font-size: 26px;
      &.c1 {
        color: #008dfe;
      }
      &.c2 {
        color: #f77671;
      }
      &.c3 {
        color: #89d572;
      }
    }
  }
}
.select-wrap {
  padding-bottom: 16px;
  display: flex;
  align-items: center;
}
.box_shadow {
  background: #ffffff;
  box-shadow: 0 0 15px 0 rgba(66, 75, 113, 0.1);
  border-radius: 4px;
}
.warp-box {
  margin-top: 24px;
  padding: 24px;
  margin-bottom: 24px;
}
.card-wrap {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  min-height: calc(100vh - 425px);
  align-content: flex-start;
  .add {
    display: flex;
    flex-direction: column;
    justify-items: center;
    justify-content: center;
    align-content: center;
    align-items: center;
    color: #999999;
    cursor: pointer;
    background: #f7faff;
    span {
      font-size: 30px;
    }
    p {
      margin-top: 10px;
    }
    &:hover {
      color: #1890ff;
      border-color: #1890ff;
    }
  }
  .item {
    width: calc(25% - 18px);
    height: 210px;
    border: 1px solid #c8c8c8;
    border-radius: 4px;
    margin: 0 18px 18px 0;
    box-sizing: border-box;
    &:nth-child(4n) {
      margin-right: 0;
    }
    .info-box {
      padding: 0 25px;
    }
    .line {
      height: 1px;
      background: #e8e8e8;
    }
    .info {
      display: flex;
      justify-content: flex-start;
      height: 70px;
      padding: 20px 0;
      img {
        margin-right: 10px;
        height: 54px;
        width: 54px;
      }
      div {
        display: flex;
        flex-direction: column;
        align-content: space-between;
        justify-content: space-around;
        p {
          font-size: 16px;
          color: #333333;
          letter-spacing: 1.67px;
        }
        .num {
          font-size: 16px;
          color: #151515;
          letter-spacing: 1.42px;
          b {
            color: #1890ff;
            letter-spacing: 2px;
            font-size: 30px;
            &.zy_color {
              color: #f5222d;
            }
            &.qt_color {
              color: #6236ff;
            }
            &.df_color {
              color: #52c41a;
            }
          }
        }
      }
    }
    .link {
      padding: 16px 0;
      display: flex;
      justify-content: space-between;
      font-size: 14px;
      color: #999999;
      align-items: center;
      span:first-child {
        cursor: pointer;
        display: flex;
        align-items: center;
      }
      b {
        color: #333333;
      }
    }
    .btn {
      display: flex;
      justify-content: space-between;
      padding: 14px 0;
      span {
        width: 50%;
        height: 20px;
        text-align: center;
        cursor: pointer;
        font-size: 14px;
        color: #999999;
        display: flex;
        align-items: center;
        justify-content: center;
        i {
          width: 16px;
          height: 16px;
          margin-right: 5px;
        }
        &:first-child {
          border-right: 1px solid #c8c8c8;
          i {
            background: url("../../../../assets/images/edit-no-active.png")
              no-repeat;
            background-size: 100% 100%;
          }
          &:hover {
            color: #1890ff;
            i {
              background: url("../../../../assets/images/edit-active.png")
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
        &:last-child {
          i {
            background: url("../../../../assets/images/del-no-active.png")
              no-repeat;
            background-size: 100% 100%;
          }
          &:hover {
            color: #1890ff;
            i {
              background: url("../../../../assets/images/del-active.png")
                no-repeat;
              background-size: 100% 100%;
            }
          }
        }
      }
    }
  }
}
.ignore-wrap {
  i.blue {
    display: inline-block;
    width: 6px;
    height: 6px;
    border-radius: 3px;
    background: #008dfe;
    vertical-align: 2px;
    margin-right: 4px;
  }
  b {
    color: #008dfe;
    margin-right: 4px;
  }
  p {
    line-height: 24px;
  }
}
</style>
